import { style } from 'typestyle'
export const fitWidth = style({ width: 'fit-content' })
